import styled from 'styled-components';

export interface SectionStyledProps {
  withTopBorder?: boolean;
  marginTop?: number;
  paddingTop?: number;
}

export const Section = styled.div<SectionStyledProps>`
  display: flex;
  flex: 1;
  width: 100%;
  ${props => props.marginTop && `margin-top: ${props.marginTop}px;`}
  ${props => props.paddingTop && `padding-top: ${props.paddingTop}px;`}
  ${props => props.withTopBorder && 'border-top: 1px solid #f0f0f0;'}
`;
